// OfferSection.jsx
import React from "react";

const features = [
  {
    id: 1,
    title: "Υπολογισμός Μορίων",
    desc: "Υπολόγισε εύκολα τα μόρια σου για κάθε σχολή",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" className="w-6 h-6">
        <rect x="3" y="3" width="18" height="18" rx="3" />
        <path d="M8 7h8M8 11h8M8 15h5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    id: 2,
    title: "Αναζήτηση Βάσεων",
    desc: "Δες βάσεις εισαγωγής για όλα τα τμήματα",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" className="w-6 h-6">
        <path d="M3 7h14M3 12h10M3 17h6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    id: 3,
    title: "Πρόσβαση σε Θέματα παλαιότερων ετών",
    desc: "Εξάσκηση με θέματα από το 2018 έως σήμερα",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" className="w-6 h-6">
        <path d="M7 3h10v4H7z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 7v11a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 12h6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    id: 4,
    title: "Χρονόμετρο Μελέτης (Pomodoro Timer)",
    desc: "Οργάνωσε τη μελέτη σου αποτελεσματικά",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" className="w-6 h-6">
        <circle cx="12" cy="12" r="8" />
        <path d="M12 8v5l3 2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

export default function OfferSection() {
  return (
    <section className="max-w-4xl mx-auto mt-6 md:mt-10 p-6 rounded-2xl bg-white/70 border border-gray-100 shadow-sm">
      <h2 className="text-xl md:text-2xl font-extrabold text-gray-900 mb-6 text-gray-700">Τι προσφέρουμε</h2>

      <div className="space-y-6 md:space-y-8">
        {features.map((f) => (
          <div
            key={f.id}
            className="flex items-start gap-5 md:gap-6 group"
          >
            <div
              className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-lg border-2 border-gray-200 bg-white/60 flex items-center justify-center text-gray-600"
              aria-hidden
            >
              {/* icon is gray via currentColor */}
              {f.icon}
            </div>

            <div className="flex-1">
              <div
                className="text-left w-full"
                aria-label={f.title}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-md md:text-lg font-bold text-gray-900 leading-tight">
                    {f.title}
                  </h3>
                </div>
                <p className="mt-1 text-xs md:text-base text-gray-500">
                  {f.desc}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
